<div class="flex gap-4 mb-6 w-full justify-between">
  <div>
    <span class="text-[24px]">Dashboard</span>
    <div class="flex gap-4">
      <span>Home</span>
      <span>Dashboard</span>
    </div>
  </div>

  <div class="flex gap-4">

    <div
      class="bg-white rounded-lg shadow-lg flex justify-center items-center gap-12 px-4"
    >
      <h2 class=" font-semibold card-heading mb-0 text-[11.35px]">
        Overall
      </h2>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3 6V8H21V6H3ZM10 18H14V16H10V18ZM18 13H6V11H18V13Z"
          fill="#525B69"
        />
      </svg>
    </div>
  </div>
</div>

<div class="grid grid-cols-1 md:grid-cols-12 gap-6 mb-6">
  <div class="bg-white rounded-lg shadow-lg md:col-span-6 p-6">
    <div class="flex justify-between content-center mb-6">
      <h2 class=" font-semibold card-heading">Daily Transactions</h2>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="15"
        viewBox="0 0 14 15"
        fill="none"
      >
        <path
          d="M8.75471 5.74989C8.59065 5.74989 8.45165 5.80686 8.33772 5.92079C8.22379 6.03472 8.16682 6.17372 8.16682 6.33778C8.16682 6.50185 8.22379 6.63857 8.33772 6.74794C8.45165 6.85732 8.59065 6.912 8.75471 6.912H12.2547C12.4188 6.912 12.5555 6.85732 12.6649 6.74794C12.7742 6.63857 12.8289 6.50185 12.8289 6.33778V2.83778C12.8289 2.67372 12.7742 2.53472 12.6649 2.42079C12.5555 2.30686 12.4188 2.24989 12.2547 2.24989C12.0907 2.24989 11.9517 2.30686 11.8377 2.42079C11.7238 2.53472 11.6668 2.67372 11.6668 2.83778V5.74989H8.75471ZM10.2313 9.05849C9.86669 10.052 9.26285 10.829 8.41975 11.3895C7.57665 11.9501 6.62646 12.2076 5.56917 12.162C4.51188 12.08 3.59586 11.7131 2.82112 11.0614C2.04638 10.4097 1.53596 9.56435 1.28987 8.52528C1.07112 7.49534 1.1691 6.5178 1.58382 5.59267C1.99853 4.66754 2.66617 3.94065 3.58675 3.412C4.51643 2.91982 5.48486 2.74436 6.49202 2.88564C7.49918 3.02691 8.38102 3.46669 9.13753 4.20497L11.8446 6.76161C11.9722 6.87099 12.1134 6.9234 12.2684 6.91884C12.4233 6.91428 12.5578 6.85048 12.6717 6.72743C12.7856 6.60439 12.8403 6.46539 12.8358 6.31044C12.8312 6.15549 12.7697 6.02333 12.6512 5.91396L9.94417 3.37099C9.00537 2.45041 7.90934 1.90126 6.65608 1.72353C5.40283 1.54579 4.19287 1.76682 3.0262 2.38661C1.86865 3.05198 1.0301 3.96116 0.510574 5.11415C-0.00895746 6.26715 -0.132004 7.49078 0.141433 8.78505C0.460444 10.0793 1.10302 11.1343 2.06917 11.9501C3.03531 12.7658 4.17919 13.2239 5.50081 13.3241C6.82242 13.3788 8.0096 13.0575 9.06233 12.3602C10.1151 11.663 10.8739 10.69 11.3387 9.4413C11.3843 9.28635 11.3752 9.13824 11.3114 8.99696C11.2476 8.85569 11.1382 8.75771 10.9832 8.70302C10.8283 8.64833 10.6802 8.65517 10.5389 8.72353C10.3976 8.79189 10.2951 8.90354 10.2313 9.05849Z"
          fill="#6B6F82"
        />
      </svg>
    </div>
    <div class="flex content-center mb-2">
      <div class="mx-6">
        <h2 class="card-body-title  font-normal mb-2">Current Day</h2>
        <h2 class="card-body-subtitle  font-semibold">₹82,124</h2>
      </div>
      <div class="mx-6">
        <h2 class="card-body-title  font-normal mb-2">Entire Week</h2>
        <h2 class="card-body-title  font-semibold">₹52,502</h2>
      </div>
    </div>
    <div class="px-6" style="display: block">
      <canvas
        baseChart
        style="width: 100%; height: 250px"
        [type]="'line'"
        [data]="lineChartData"
        [options]="lineChartOptions"
        [legend]="false"
      >
      </canvas>
    </div>
  </div>

  <div class="grid grid-cols-1 md:col-span-6 md:grid-cols-12 gap-6">

    <div class="bg-white rounded-lg shadow-lg md:col-span-6">
      <div class="flex justify-between items-center px-6 pt-6">
          <h2 class="currency  font-semibold text-[#198754]">₹32,454</h2>
          <div class="">
            <svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none">
                <g clip-path="url(#clip0_1688_12981)">
                    <path d="M42.4137 12.699L42.4374 36.7927C42.4374 38.9556 40.6781 40.7148 38.5152 40.7148H4.50421C2.34129 40.7148 0.582031 38.9556 0.582031 36.7927V15.8817C0.582031 13.7237 2.33394 11.9702 4.4895 11.9612L5.7969 11.9645V6.70628C5.7969 4.54255 7.55534 2.7841 9.71907 2.7841L9.99036 2.81189L39.2335 8.6927C42.1727 9.47796 42.4333 11.7324 42.4137 12.699ZM8.41168 6.70628V11.9604H37.1874C38.2349 11.9743 38.4597 11.2462 38.449 11.2413L9.60468 5.40379C8.93791 5.46099 8.41168 6.02317 8.41168 6.70628ZM39.8234 36.7927H39.8226V13.2718C39.8226 14.1372 38.4752 14.5743 37.1915 14.5743H4.50421C3.78269 14.5743 3.19682 15.1602 3.19682 15.8817V36.7927C3.19682 37.515 3.78269 38.1001 4.50421 38.1001H38.516C39.2376 38.1001 39.8234 37.515 39.8234 36.7927ZM8.42884 23.731C9.87269 23.731 11.0436 24.9019 11.0436 26.3458C11.0436 27.7896 9.87269 28.9606 8.42884 28.9606C6.98499 28.9606 5.81405 27.7896 5.81405 26.3458C5.81405 24.9019 6.98499 23.731 8.42884 23.731Z" fill="#CED4DA"/>
                </g>
                <defs>
                    <clipPath id="clip0_1688_12981">
                    <rect width="42" height="42" fill="white" transform="matrix(1 0 0 -1 0.5 42.75)"/>
                    </clipPath>
                </defs>
            </svg>
          </div>
      </div>
      <h2 class=" font-semibold mb-8 text-[24px] text-[#0058e9] px-6">Pay In</h2>
       <canvas
        baseChart
        style="width: 100%; height: 150px"
        [type]="'line'"
        [data]="lineChartData1"
        [options]="lineChartOptions1"
        [legend]="false"
      >
      </canvas>
    </div>

    <div class="bg-white rounded-lg shadow-lg md:col-span-6">
      <div class="flex justify-between items-center px-6 pt-6">
          <h2 class="currency  font-semibold text-[#198754]">₹32,454</h2>
          <div class="">
            <svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none">
                <g clip-path="url(#clip0_1688_12981)">
                    <path d="M42.4137 12.699L42.4374 36.7927C42.4374 38.9556 40.6781 40.7148 38.5152 40.7148H4.50421C2.34129 40.7148 0.582031 38.9556 0.582031 36.7927V15.8817C0.582031 13.7237 2.33394 11.9702 4.4895 11.9612L5.7969 11.9645V6.70628C5.7969 4.54255 7.55534 2.7841 9.71907 2.7841L9.99036 2.81189L39.2335 8.6927C42.1727 9.47796 42.4333 11.7324 42.4137 12.699ZM8.41168 6.70628V11.9604H37.1874C38.2349 11.9743 38.4597 11.2462 38.449 11.2413L9.60468 5.40379C8.93791 5.46099 8.41168 6.02317 8.41168 6.70628ZM39.8234 36.7927H39.8226V13.2718C39.8226 14.1372 38.4752 14.5743 37.1915 14.5743H4.50421C3.78269 14.5743 3.19682 15.1602 3.19682 15.8817V36.7927C3.19682 37.515 3.78269 38.1001 4.50421 38.1001H38.516C39.2376 38.1001 39.8234 37.515 39.8234 36.7927ZM8.42884 23.731C9.87269 23.731 11.0436 24.9019 11.0436 26.3458C11.0436 27.7896 9.87269 28.9606 8.42884 28.9606C6.98499 28.9606 5.81405 27.7896 5.81405 26.3458C5.81405 24.9019 6.98499 23.731 8.42884 23.731Z" fill="#CED4DA"/>
                </g>
                <defs>
                    <clipPath id="clip0_1688_12981">
                    <rect width="42" height="42" fill="white" transform="matrix(1 0 0 -1 0.5 42.75)"/>
                    </clipPath>
                </defs>
            </svg>
          </div>
      </div>
      <h2 class=" font-semibold mb-8 text-[24px] text-[#0058e9] px-6">Pay Out</h2>
       <canvas
        baseChart
        style="width: 100%; height: 150px"
        [type]="'line'"
        [data]="lineChartData2"
        [options]="lineChartOptions1"
        [legend]="false"
      >
      </canvas>
    </div>

    <div class="bg-[#612B89] rounded-lg shadow-lg md:col-span-12 p-6 flex justify-between items-center">
      <div class="flex justify-between items-center">
          <div class="flex gap-12 items-center">
            <h2 class="text-[24px]  font-semibold text-white">₹32,454</h2>
            <h2 class="text-[20px]  font-normal text-white">Live Balance</h2>
          </div>
      </div>
      <div class="">
        <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
          <path d="M41.9135 11.949L41.9372 36.0427C41.9372 38.2056 40.1779 39.9648 38.015 39.9648H4.00397C1.84105 39.9648 0.0817871 38.2056 0.0817871 36.0427V15.1317C0.0817871 12.9737 1.83369 11.2202 3.98926 11.2112L5.29665 11.2145V5.95628C5.29665 3.79255 7.05509 2.0341 9.21883 2.0341L9.49011 2.06189L38.7332 7.9427C41.6724 8.72796 41.9331 10.9824 41.9135 11.949ZM7.91144 5.95628V11.2104H36.6872C37.7347 11.2243 37.9594 10.4962 37.9488 10.4913L9.10443 4.65379C8.43766 4.71099 7.91144 5.27317 7.91144 5.95628ZM39.3232 36.0427H39.3224V12.5218C39.3224 13.3872 37.9749 13.8243 36.6912 13.8243H4.00397C3.28245 13.8243 2.69657 14.4102 2.69657 15.1317V36.0427C2.69657 36.765 3.28245 37.3501 4.00397 37.3501H38.0158C38.7373 37.3501 39.3232 36.765 39.3232 36.0427ZM7.9286 22.981C9.37245 22.981 10.5434 24.1519 10.5434 25.5958C10.5434 27.0396 9.37245 28.2106 7.9286 28.2106C6.48474 28.2106 5.31381 27.0396 5.31381 25.5958C5.31381 24.1519 6.48474 22.981 7.9286 22.981Z" fill="white"/>
          <path d="M41.9135 11.949L41.9372 36.0427C41.9372 38.2056 40.1779 39.9648 38.015 39.9648H4.00397C1.84105 39.9648 0.0817871 38.2056 0.0817871 36.0427V15.1317C0.0817871 12.9737 1.83369 11.2202 3.98926 11.2112L5.29665 11.2145V5.95628C5.29665 3.79255 7.05509 2.0341 9.21883 2.0341L9.49011 2.06189L38.7332 7.9427C41.6724 8.72796 41.9331 10.9824 41.9135 11.949ZM7.91144 5.95628V11.2104H36.6872C37.7347 11.2243 37.9594 10.4962 37.9488 10.4913L9.10443 4.65379C8.43766 4.71099 7.91144 5.27317 7.91144 5.95628ZM39.3232 36.0427H39.3224V12.5218C39.3224 13.3872 37.9749 13.8243 36.6912 13.8243H4.00397C3.28245 13.8243 2.69657 14.4102 2.69657 15.1317V36.0427C2.69657 36.765 3.28245 37.3501 4.00397 37.3501H38.0158C38.7373 37.3501 39.3232 36.765 39.3232 36.0427ZM7.9286 22.981C9.37245 22.981 10.5434 24.1519 10.5434 25.5958C10.5434 27.0396 9.37245 28.2106 7.9286 28.2106C6.48474 28.2106 5.31381 27.0396 5.31381 25.5958C5.31381 24.1519 6.48474 22.981 7.9286 22.981Z" fill="white" fill-opacity="0.2"/>
        </svg>
      </div>
    </div>

  </div>
</div>

<!-- <div class="grid grid-cols-1 md:grid-cols-3"> -->
<div
  class="bg-white rounded-lg shadow-lg md:col-span-3 p-6 mb-6"
>
    <h2 class="text-[16px] text-[#0058e9] font-sans font-bold"> Transactions </h2>
  <div class="grid grid-cols-1 md:grid-cols-3">
    <div class="md:col-span-1 border-r-2">
      <h2 class="status-text text-[#0CAF60] font-sans">Success</h2>
      <div class="px-20 py-8" style="display: block">
        <canvas baseChart style="width: 100%; height: 180px;"
                  [datasets]="doughnutChartDatasets1"
                  [options]="doughnutChartOptions"
                  [legend]="false"
                  [type]="'doughnut'">
                  </canvas>
      </div>
      <div class="flex justify-center items-center gap-6">
        <div>
          <h2 class="text-[24px] text-center text-[#6C757D] font-sans">40</h2>
          <h2 class="text-[14px] text-center font-semibold text-[#0058e9] font-sans"> Number </h2>
        </div>
        <div>
          <h2 class="text-[24px] text-center text-[#6C757D] font-sans">2000000</h2>
          <h2 class="text-[14px] text-center font-semibold text-[#0058e9] font-sans"> Amount </h2>
        </div>
      </div>
    </div>
    <!-- </div>
        <div class="bg-white rounded-lg shadow-lg md:col-span-1 p-6"> -->
    <div class="md:col-span-1 border-r-2">
      <h2 class="status-text text-[#FF3A6E] font-sans">Failed</h2>
      <div class="px-20 py-8" style="display: block">
        <canvas baseChart style="width: 100%; height: 180px;"
                  [datasets]="doughnutChartDatasets2"
                  [options]="doughnutChartOptions"
                  [legend]="false"
                  [type]="'doughnut'">
                  </canvas>
      </div>
      <div class="flex justify-center items-center gap-6">
        <div>
          <h2 class="text-[24px] text-center text-[#6C757D] font-sans">40</h2>
          <h2 class="text-[14px] text-center font-semibold text-[#0058e9] font-sans"> Number </h2>
        </div>
        <div>
          <h2 class="text-[24px] text-center text-[#6C757D] font-sans">2000000</h2>
          <h2 class="text-[14px] text-center font-semibold text-[#0058e9] font-sans"> Amount </h2>
        </div>
      </div>
    </div>
    <!-- </div>
        <div class="bg-white rounded-lg shadow-lg md:col-span-1 p-6"> -->
    <div class="md:col-span-1">
      <h2 class="status-text text-[#0058e9] font-sans">Total</h2>
      <div class="px-20 py-8" style="display: block">
        <canvas baseChart style="width: 100%; height: 180px;"
                  [datasets]="doughnutChartDatasets3"
                  [options]="doughnutChartOptions"
                  [legend]="false"
                  [type]="'doughnut'">
                  </canvas>
      </div>
      <div class="flex justify-center items-center gap-6">
        <div>
          <h2 class="text-[24px] text-center text-[#6C757D] font-sans">40</h2>
          <h2 class="text-[14px] text-center font-semibold text-[#0058e9] font-sans"> Number </h2>
        </div>
        <div>
          <h2 class="text-[24px] text-center text-[#6C757D] font-sans">2000000</h2>
          <h2 class="text-[14px] text-center font-semibold text-[#0058e9] font-sans"> Amount </h2>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="bg-white rounded-lg shadow-lg md:col-span-3 px-12 py-6"
>
    <h2 class="text-[16px] text-[#0058e9] font-sans font-bold"> KYC </h2>

    <canvas baseChart
  [type]="'pie'"
  [datasets]="pieChartDatasets"
  [labels]="pieChartLabels"
  [options]="pieChartOptions"
  [plugins]="pieChartPlugins"
  [legend]="true">
</canvas>


</div>
